import React from "react";
import { useNavigate } from "react-router-dom";

function Navbar2() {
    const navigate = useNavigate();

    const customerType = sessionStorage.getItem("customerType");
    // console.log("customer Type:", customerType);

    const home = () => {
        navigate("/home");
    };
    const contactus = () => {
        navigate("/contact");
    };

    const findjob = () => {
        navigate("/searchedjobs");
    };

    const jobcategories = () => {
        navigate("/jobcategories");
    };

    const jobnames = () => {
        navigate("/jobnames");
    };

    const jobidpage = () => {
        navigate("/jobid");
    };

    const martial = () => {
        navigate("/martialstatus");
    };

    const sevicespage = () => {
        navigate("/services");
    };

    const whatsappPage = () => {
        navigate("/whatsapp");
    };

    const datesearch = () => {
        navigate("/datesearch");
    };

    return (
        <div className="h-[48px] w-full bg-[#D22D3A] flex flex-row gap-12 justify-center items-center">
            <span className="text-base font-[600] font-display text-[white] cursor-pointer hover:text-black" onClick={home}>
                Home
            </span>
            {customerType && (
                <span
                    className="text-base font-[600] font-display text-[white] cursor-pointer hover:text-black"
                    onClick={findjob}
                >
                    Find Jobs
                </span>
            )}
            {(customerType === "admin" || customerType === "mainAdmin") && (
                <span
                    className="text-base font-[600] font-display text-[white] cursor-pointer hover:text-black"
                    onClick={jobcategories}
                >
                    Job By Categories
                </span>
            )}
            {(customerType === "admin" || customerType === "mainAdmin") && (
                <span
                    className="text-base font-[600] font-display text-[white] cursor-pointer hover:text-black"
                    onClick={jobnames}
                >
                    Job Names
                </span>
            )}

            <span
                className="text-base font-[600] font-display text-[white] cursor-pointer hover:text-black"
                onClick={jobidpage}
            >
                Job ID Search
            </span>
            {(customerType === "admin" || customerType === "mainAdmin") && (
                <span
                    className="text-base font-[600] font-display text-[white] cursor-pointer hover:text-black"
                    onClick={martial}
                >
                    Marital Status
                </span>
            )}
            {(customerType === "admin" || customerType === "mainAdmin") && (
                <span
                    className="text-base font-[600] font-display text-[white] cursor-pointer hover:text-black"
                    onClick={whatsappPage}
                >
                    To Whatsapp
                </span>
            )}
            {/* {(customerType === 'admin' || customerType === 'mainAdmin') && (
        <span className='text-base font-[600] font-display text-[white] cursor-pointer hover:text-black' onClick={datesearch}>Date Search</span>
      )} */}
            <span
                className="text-base font-[600] font-display text-[white] cursor-pointer hover:text-black"
                onClick={sevicespage}
            >
                Services
            </span>
            <span
                className="text-base font-[600] font-display text-[white] cursor-pointer hover:text-black"
                onClick={contactus}
            >
                Contact Us
            </span>
        </div>
    );
}

export default Navbar2;
